import React from "react";

/*
    Left Icon
    props:
        - title: string, override the default title 'large-down-arrow'
        - color: string, override the default color '#00549A' (bell blue)
*/

const LargeDownIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "large-down-arrow"}</title>
        <path d="M20 8L12 15.5L4 8" stroke={props.color || "#00549A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default LargeDownIcon;
